import { render, staticRenderFns } from "./DropZoneDialog.vue?vue&type=template&id=91af4b0c&scoped=true"
import script from "./DropZoneDialog.vue?vue&type=script&lang=js"
export * from "./DropZoneDialog.vue?vue&type=script&lang=js"
import style0 from "./DropZoneDialog.vue?vue&type=style&index=0&id=91af4b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91af4b0c",
  null
  
)

export default component.exports